import { mapPersonFields } from '@/adapters/persons'
import { directusClient, imageFields, readItems } from '@/shared/utils/directus'

export interface GetPersonsParams {
  locale?: string
  workgroupIds?: string[]
  categorySlugs?: string[]
  countryId?: number | string
}

export default async function getPersons({
  locale = 'ru-RU',
  workgroupIds,
  categorySlugs,
  countryId,
}: GetPersonsParams = {}) {
  const collectionName = 'persons'

  const filter = {
    translations: { languages_code: { _eq: locale } },
    workgroups: workgroupIds?.length ? { workgroup: { _in: workgroupIds } } : undefined,
    categories: categorySlugs?.length ? { category: { slug: { _in: categorySlugs } } } : undefined,
    country:
      (typeof countryId === 'number' && countryId > 0) || (typeof countryId === 'string' && !!countryId)
        ? countryId
        : undefined,
  }

  try {
    const itemsRaw = await directusClient.request<Directus.Person[]>(
      readItems(collectionName, {
        sort: locale === 'ru-RU' ? ['name'] : ['name_en', 'name'],
        filter,
        deep: {
          translations: { _filter: { languages_code: { _eq: locale } } },
          posts: {
            post: { _filter: { status: { _eq: 'published' }, translations: { languages_code: { _eq: locale } } } },
          },
        },
        fields: [
          'id',
          {
            translations: ['name', 'position'],
            image: imageFields,
            posts: ['id'],
          },
        ],
      })
    )

    const items = itemsRaw?.map(item => {
      return mapPersonFields(item)
    })

    return items
  } catch (error) {
    return []
  }
}

export async function getExperts({
  locale = 'ru-RU',
  workgroupIds,
  countryId,
}: Omit<GetPersonsParams, 'categorySlugs'> = {}) {
  return await getPersons({ locale, workgroupIds, countryId, categorySlugs: ['experts'] })
}
